import * as React from "react";
import { TextInput, TextInputProps } from "./TextInput";
import { FormFieldString } from "../../commonTypes/formField.types";

//const DEFAULT_STATE_VALUE = '';

export class ControlledTextInput extends React.PureComponent<TextInputProps> {
  static defaultProps = {
    fieldName: "",
    value: "",
    isRequired: false,
    changeOnBlur: true,
    errorMessage: "",
    showMaxLengthMessage: false,
    type: "text",
    classNames: "",
    disabled: false,
    readonly: false,
    actAsNumber: false,
    min: 0,
    isTouched: false,
    hidden: false,
    isWrappedByControlledElement: true,
    onChange: () => {
      /* noop */
    },
    onBlur: () => {},
  } as TextInputProps;

  constructor(props: TextInputProps) {
    super(props);

    this.state = {
      ...this.props,
    };
  }

  static getDerivedStateFromProps(
    newProps: TextInputProps,
    currentState: FormFieldString
  ) {
    if (newProps.value !== currentState.value) {
      const { errorMessage, value } = newProps;
      return {
        value: value,
        errorMessage,
      };
    }
    return null;
  }

  public render() {
    return (
      <React.Fragment>
        <TextInput
          {...this.props}
          onBlur={this.props.onBlur}
          onChange={this.props.onChange}
        />
      </React.Fragment>
    );
  }
}
